<template>
  <div class="pages">
    <headers @dealWithData="dealWithData" />
    <div class="main">
      <div class="tabTop">
        <div class="tab">
          <p :class="tabCheck == 0?'checkTap':''" class="allp" @click="tabCheckTap(0)">全部项目</p>
          <p :class="tabCheck == 1?'checkTap':''" class="noDownp" @click="tabCheckTap(1)">未下载项目</p>
        </div>
      </div>

      <div class="projectList">
        <!-- 插入 -->
        <div class="projectItem" v-if="stepsNum == 4" @click="openFour">
          <div class="itemleft">
            <div class="projectName">{{projectInfo.name}}</div>
            <div class="projectInfo">
              <span style="margin-right:10px;">{{firstStep.many}}张</span>
              <span v-if="firstStep.size < 1024">{{firstStep.size}}B</span>
              <span
                v-else-if="1024 <= this.firstStep.size && this.firstStep.size < 1048576"
              >{{(firstStep.size / 1024).toFixed(1)}}KB</span>
              <span
                v-else-if="1048576 <= this.firstStep.size && this.firstStep.size < 1073741824"
              >{{(firstStep.size/1048576).toFixed(1)}}MB</span>
              <span
                v-else-if="1073741824 <= this.firstStep.size && this.firstStep.size < 1099511627776"
              >{{(firstStep.size/1073741824).toFixed(1)}}GB</span>
            </div>
          </div>

          <div class="itemRight">
            <div class="partInfo">
              <span style="margin-right:10px;">{{upLoadCover.length}}/{{firstStep.many}}</span>
              <!-- <span>预计55分钟</span> -->
              <el-dropdown>
                <span class="el-dropdown-link">
                  <div class="projectStatus downloadStyle">
                    <div
                      class="progressDiv"
                      :style="{left:`${ (upLoadCover.length * 100) / secondArr.length - 100}%`}"
                    ></div>
                    <div class="topLayer el-dropdown-link">
                      <div style="width:8px;height:8px"></div>
                      <p>上传中</p>
                      <img src="../../assets/img/downLoadW.svg" alt class="onUpLoad" />
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>进度详情</el-dropdown-item>
                      <el-dropdown-item>取消交付</el-dropdown-item>
                    </el-dropdown-menu>
                  </div>
                </span>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div
          class="projectItem"
          v-for="(item,index) in projectList.list"
          :key="index"
          @click.self="getProDetails(item.id,item.restDate)"
        >
          <div class="itemleft">
            <div class="projectName">{{item.name}}</div>
            <div class="projectInfo">
              <span style="margin-right:10px;">{{item.file_total_num}}张</span>

              <span v-if="item.file_total_size < 1024">{{item.file_total_size}}B</span>
              <span
                v-else-if="1024 <= item.file_total_size && item.file_total_size < 1048576"
              >{{(item.file_total_size / 1024).toFixed(1)}}KB</span>
              <span
                v-else-if="1048576 <= item.file_total_size && item.file_total_size < 1073741824"
              >{{(item.file_total_size/1048576).toFixed(1)}}MB</span>
              <span
                v-else-if="1073741824 <= item.file_total_size && item.file_total_size < 1099511627776"
              >{{(item.file_total_size/1073741824).toFixed(1)}}GB</span>
            </div>
          </div>

          <div class="itemRight">
            <div class="partInfo">
              <span v-if="item.restDate != -1">{{item.restDate}}后过期</span>
              <span v-else>已过期</span>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <div>
                    <div class="styleStatus downloadStyle">
                      <template v-if="item.restDate != -1">
                        <div class="pointR" v-if="item.is_download == 0"></div>
                        <div class="pointG" v-else></div>
                      </template>
                      <template v-else>
                        <div class="pointR"></div>
                      </template>

                      <template v-if="item.restDate != -1">
                        <p v-if="item.is_download == 0">客户未下载</p>
                        <p v-else>客户已下载</p>
                      </template>
                      <template v-else>
                        <p>项目已过期</p>
                      </template>

                      <img src="../../assets/img/downLoadB.svg" alt />
                    </div>
                    <template v-if="item.restDate != -1">
                      <el-dropdown-menu slot="dropdown" v-if="item.is_download == 0">
                        <el-dropdown-item
                          :command="{type:'share',id:item.id}"
                          class="shareUrl"
                          :data-clipboard-text="shareUrl"
                        >分享项目</el-dropdown-item>
                      </el-dropdown-menu>
                      <el-dropdown-menu slot="dropdown" v-if="item.is_download == 1">
                        <el-dropdown-item
                          :command="{type:'share',id:item.id}"
                          class="shareUrl"
                          :data-clipboard-text="shareUrl"
                        >分享项目</el-dropdown-item>
                        <el-dropdown-item :command="{type:'delete',id:item.id}">删除项目</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                    <template v-else>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{type:'delete',id:item.id}">删除项目</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </div>
                </span>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :total="projectList.total_count"
          @current-change="currentChange"
        ></el-pagination>
        <div class="current">
          <div class="inputCurrent">
            <input type="text" :value="currentPage" @keyup.enter="onEnter" @input="onEnter($event)" />
          </div>
          /{{projectList.total_page}}
        </div>
        <span>共:{{projectList.total_count}}条</span>
      </div>
    </div>

    <!-- 添加项目的弹窗 -->
    <div class="maskPopUp" v-if="stepsNum != 0 && dynamic">
      <div class="maskContent">
        <div class="contentHeader">
          <img v-if="stepsNum == 1" src="../../assets/img/stepsOne.svg" alt class="stepsOne" />
          <img v-if="stepsNum == 2" src="../../assets/img/stepsTwo.svg" alt class="stepsOne" />
          <img v-if="stepsNum == 3" src="../../assets/img/stepsThree.svg" alt class="stepsOne" />
          <img v-if="stepsNum == 4" src="../../assets/img/stepsFour.svg" alt class="stepsOne" />
          <img v-if="stepsNum == 5" src="../../assets/img/stepsOver.svg" alt class="stepsOne" />
          <img src="../../assets/img/stepsClose.svg" alt class="stepsClose" @click="stepsClose" />
        </div>

        <div class="contentMain">
          <div class="stepsTitle" v-if="stepsNum == 1">
            <p class="titleName">添加需要交付的文件或者文件夹</p>
            <p class="titleInfo">
              <span>{{firstStep.many}}张</span>
              <span style="margin-left:10px" v-if="firstStep.size < 1024">{{firstStep.size}}B</span>
              <span
                style="margin-left:10px"
                v-else-if="1024 <= this.firstStep.size && this.firstStep.size < 1048576"
              >{{(firstStep.size / 1024).toFixed(1)}}KB</span>
              <span
                style="margin-left:10px"
                v-else-if="1048576 <= this.firstStep.size && this.firstStep.size < 1073741824"
              >{{(firstStep.size/1048576).toFixed(1)}}MB</span>
              <span
                style="margin-left:10px"
                v-else-if="1073741824 <= this.firstStep.size && this.firstStep.size < 1099511627776"
              >{{(firstStep.size/1073741824).toFixed(1)}}GB</span>
            </p>
          </div>

          <div class="stepsTitle" v-if="stepsNum == 2">
            <p class="titleName">筛选出要加入精选的内容</p>
            <p class="titleInfo">
              <!-- <span>{{secondXcx.length}}/18</span> -->
            </p>
          </div>

          <div class="stepsTitle" v-if="stepsNum == 3">
            <p class="titleName">交付设置</p>
          </div>

          <div class="stepsTitle" v-if="stepsNum == 4">
            <p class="titleName">文件上传中...</p>
            <p class="titleInfo">
              <span>{{firstStep.many}}张</span>
              <span style="margin-left:10px" v-if="firstStep.size < 1024">{{firstStep.size}}B</span>
              <span
                style="margin-left:10px"
                v-else-if="1024 <= firstStep.size && firstStep.size < 1048576"
              >{{(firstStep.size / 1024).toFixed(1)}}KB</span>
              <span
                style="margin-left:10px"
                v-else-if="1048576 <= firstStep.size && firstStep.size < 1073741824"
              >{{(firstStep.size/1048576).toFixed(1)}}MB</span>
              <span
                style="margin-left:10px"
                v-else-if="1073741824 <= firstStep.size && firstStep.size < 1099511627776"
              >{{(firstStep.size/1073741824).toFixed(1)}}GB</span>
            </p>
          </div>

          <!-- 第一步的内容 -->
          <div class="filelist" v-if="stepsNum == 1">
            <div class="fileItem" v-for="(item,index) in firstStep.arr" :key="index">
              <div class="imgDiv">
                <img src="../../assets/img/folder.svg" alt class="folderIcon" />
                <img
                  src="../../assets/img/fileClose.svg"
                  alt
                  class="fileClose"
                  @click="deleteFile(index)"
                />
              </div>
              <span>{{item.fileName}}</span>
            </div>

            <div class="addFileBtn">
              <input type="file" webkitdirectory multiple @change="addPrice($event)" />
              <img src="../../assets/img/addImg.png" alt />
            </div>
          </div>

          <!-- 第二步 -->
          <div class="classifyFile" v-if="stepsNum == 2">
            <div class="imgList">
              <p>全部图片</p>
              <div class="allPhoto">
                <div class="imgItem" v-for="(item,index) in secondArr" :key="index">
                  <div class="imgLoadMask" v-if="!item.loading">加载中...</div>
                  <img :src="item.url" alt class="imgItemimg" @load="imgLoad(index)" />
                  <img
                    v-if="item.is_choice == 0"
                    src="../../assets/img/noCheck.svg"
                    alt
                    class="checkImg"
                    @click="checkImg(index,1)"
                  />
                  <img
                    v-if="item.is_choice == 1"
                    src="../../assets/img/check.svg"
                    alt
                    class="checkImg"
                    @click="checkImg(index,0)"
                  />
                </div>
              </div>
            </div>
            <div class="imgList" style="width:352px;margin-left:30px">
              <p>当前精选</p>
              <div class="allPhoto selectImg">
                <div class="imgItem" v-for="(item,index) in secondXcx" :key="index" @click="cancelSe(index)">
                  <img :src="item.url" alt class="imgItemimg" />
                  <img src="../../assets/img/check.svg" alt class="checkImg" />
                </div>
              </div>
            </div>
          </div>

          <!-- 第三步 -->
          <div class="addProjectInfo" v-if="stepsNum == 3">
            <div class="projectFormItem">
              <p>项目名称</p>
              <div class="formItem">
                <div class="inputBg">
                  <input
                    type="text"
                    maxlength="10"
                    name
                    placeholder="请输入项目名称"
                    @keyup.enter="projectName"
                    @input="projectName($event)"
                  />
                  <span>{{projectInfo.name.length || 0}}/10</span>
                </div>
              </div>
            </div>

            <div class="projectFormItem">
              <p>作品类型</p>
              <div class="formItem">
                <el-dropdown>
                  <div class="downDrop" :class="project1?'':'placeholderStyle'">
                    {{project1?project1:'选择'}}
                    <img src="../../assets/img/downLoadB.svg" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in projectIn"
                      :key="index"
                      @click.native="categoryId(item)"
                    >{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown>
                  <div class="downDrop" :class="project2?'':'placeholderStyle'">
                    {{project2?project2:'选择'}}
                    <img src="../../assets/img/downLoadB.svg" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in projectTwoIn"
                      :key="index"
                      @click.native="categoryIdTwo(item)"
                    >{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div class="projectFormItem">
              <p>客户行业</p>
              <div class="formItem">
                <el-dropdown>
                  <div class="downDrop" :class="project3?'':'placeholderStyle'">
                    {{project3?project3:'选择'}}
                    <img src="../../assets/img/downLoadB.svg" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in customerIn"
                      :key="index"
                      @click.native="customerId(item)"
                    >{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown>
                  <div class="downDrop" :class="project4?'':'placeholderStyle'">
                    {{project4?project4:'选择'}}
                    <img src="../../assets/img/downLoadB.svg" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item,index) in customerTwoIn"
                      :key="index"
                      @click.native="customerTwoId(item)"
                    >{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div class="projectFormItem">
              <p>提取人手机号</p>
              <div class="formItem">
                <div class="inputBg">
                  <input
                    type="text"
                    style="width:272px"
                    name
                    placeholder="请输入提取人手机号"
                    @keyup.enter="phoneList"
                    @input="phoneList($event)"
                  />
                </div>
              </div>
            </div>

            <div class="projectFormItem">
              <p></p>
              <div class="formItem">
                <div class="formItemTip">
                  <img src="../../assets/img/tip.svg" alt />
                  <span>多个提取人之间用分号分割</span>
                </div>
              </div>
            </div>

            <div class="projectFormItem">
              <p>同步至百度网盘</p>
              <div class="formItem">
                <div style="display:flex;align-items:center;">
                  <el-switch
                    class="switch"
                    v-model="elSwitch"
                    active-color="#000000"
                    inactive-color="#DCDCDC"
                    on-value="1"
                    off-value="0"
                    @change="synchronous($event)"
                  ></el-switch>

                  <div class="pretentBtn" v-if="baiduIsOauth.oauth == 0" @click="bindBaidu">绑定网盘</div>
                  <div class="formItemTip" v-if="baiduIsOauth.oauth == 0">
                    <img src="../../assets/img/tip.svg" alt />
                    <span>首次同步需要绑定</span>
                  </div>

                  <div class="baiduName" v-if="baiduIsOauth.oauth == 1">{{baiduIsOauth.username}}</div>
                  <div class="formItemTip" v-if="baiduIsOauth.oauth == 1">
                    <span>解绑</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 第四步 -->
          <div class="progressList" v-if="stepsNum == 4">
            <p class="proTip">上传成功前，请勿刷新或关闭浏览器</p>
            <div class="allPro">
              <div
                class="sucPro"
                :style="{width:`${(upLoadCover.length * 100) / upLoadIng.length }%`}"
              ></div>
            </div>
            <div class="tabList">
              <div
                class="tabItem"
                @click="transmission"
                :class="transmissionStatus == 0?'tabCheck':''"
              >传输中</div>
              <div
                class="tabItem"
                :class="transmissionStatus == 1?'tabCheck':''"
                @click="coverImg"
              >已完成</div>
            </div>

            <div class="progress" v-if="transmissionStatus == 0">
              <div v-for="(item,index) in upLoadIng" :key="index">
                <div v-if="item.imgLoadPercent != 100" class="progressFile">
                  <div class="fileLeft">
                    <img :src="item.url" alt />
                    <div class="fileInfo">
                      <p class="fileInfoP1">{{item.file.name}}</p>
                      <p class="fileInfoP2">
                        <span v-if="item.loaded  < 1024 ">{{item.loaded}}B</span>
                        <span
                          v-else-if="1024 <= item.loaded &&item.loaded < 1048576 "
                        >{{(item.loaded / 1024).toFixed(1)}}KB</span>
                        <span
                          v-else-if="1048576 <= item.loaded && item.loaded < 1073741824 "
                        >{{(item.loaded/1048576).toFixed(1)}}MB</span>
                        <span
                          v-else-if="1073741824 <= item.loaded && item.loaded < 1099511627776 "
                        >{{(item.loaded/1073741824).toFixed(1)}}GB</span>
                        /
                        <span v-if="item.size  < 1024 ">{{item.size}}B</span>
                        <span
                          v-else-if="1024 <= item.size &&item.size < 1048576 "
                        >{{(item.size / 1024).toFixed(1)}}KB</span>
                        <span
                          v-else-if="1048576 <= item.size && item.size < 1073741824 "
                        >{{(item.size/1048576).toFixed(1)}}MB</span>
                        <span
                          v-else-if="1073741824 <= item.size && item.size < 1099511627776 "
                        >{{(item.size/1073741824).toFixed(1)}}GB</span>
                      </p>
                    </div>
                  </div>
                  <div class="fileRight">
                    <div class="filePro" :style="{width:`${item.imgLoadPercent}%`}"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="progress" v-if="transmissionStatus == 1">
              <div class="progressFile" v-for="(item,index) in upLoadCover" :key="index">
                <div class="fileLeft">
                  <img :src="item.url" alt />
                  <div class="fileInfo">
                    <p class="fileInfoP1">{{item.file.name}}</p>
                    <p class="fileInfoP2">300K/3.2M</p>
                  </div>
                </div>
                <div class="fileRight">
                  <div class="filePro" :style="{width:`${item.imgLoadPercent}%`}"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 第五步 -->
          <div class="addCover" v-if="stepsNum == 5">
            <div class="centerCover">
              <img src="../../assets/img/addProjectCover.svg" alt />
              <p>项目交付成功，你可以关闭网页了</p>
              <div class="tipList">
                <ul>
                  <li>全部作品的提取连接已经短信发送给客户</li>
                  <li>全部作品将在1小时内备份至网盘</li>
                  <li>精选作品已经存入云作品</li>
                </ul>
              </div>
            </div>
            <div class="goDetails" @click="getProDetails(projectList.list[0].id,1)">进入详情</div>
          </div>

          <div class="next" v-if="stepsNum < 4">
            <img
              src="../../assets/img/upStep.svg"
              class="upStep"
              @click="upStep"
              v-if="stepsNum != 1"
            />
            <img src="../../assets/img/next.svg" alt @click="nextBtn" />
          </div>
        </div>
      </div>
    </div>

    <!-- 退出和二维码的弹窗 -->
    <div class="maskOut" v-if="false">
      <!-- 退出弹框 -->
      <div class="outMask" v-if="false">
        <div class="outClose">
          <img src="../../assets/img/stepsClose.svg" alt />
        </div>
        <p class="titleP">是否退出交付工具</p>
        <p class="titleG">你可以在小程序中找到项目</p>
        <div class="btnMoni">
          <div class="noOut">暂不退出</div>
          <div class="okOut" @click="outOk">确定退出</div>
        </div>
      </div>

      <!-- 二维码弹框 -->
      <div class="qrCodeView">
        <div class="closeIcon">
          <p>提交反馈</p>
          <img src="../../assets/img/stepsClose.svg" alt />
        </div>
        <div class="qrCodeImg">
          <img src alt />
        </div>
        <p>手机扫码在小程序提交问题反馈</p>
      </div>
    </div>
    <top-tip :visible="reviewTip" message="未通过监管审核" />
  </div>
</template>

<script>
import TopTip from "@/components/TopTip.vue";
import headers from "../../components/header";
import lrz from "lrz";
let axios = require("axios");
import Clipboard from "clipboard";

import {
  works,
  customerIndustries,
  workCategories,
  qiniuGetParams,
  createPro,
  getDetails,
  isOauth,
  deleteDetails
} from "@/request/api";

export default {
  components: { TopTip, headers },
  name: "userHome",
  data() {
    return {
      reviewTip: false,
      tabCheck: 0,
      stepsNum: 0,
      dynamic: true,
      project1: "",
      project2: "",
      project3: "",
      project4: "",
      customerIn: [],
      customerTwoIn: [],
      projectIn: [],
      projectTwoIn: [],
      shareUrl: "https://zuopin.cloud/home/index.html#/customerLogin",
      currentPage: 1,
      inputValue: "1",
      firstStep: { arr: [], size: 0, many: 0 },
      secondArr: [],
      secondXcx: [],
      elSwitch: false,
      projectInfo: {
        name: "",
        category_id: null,
        customer_industry_id: null,
        customer_phone_list: "",
        is_sync_pan: 0,
        file_list: []
      },
      transmissionStatus: 0,
      showArr: [],
      upLoadIng: [],
      upLoadCover: [],
      projectList: {},
      baiduIsOauth: {}
    };
  },
  mounted() {
    this.worksList(-1, 1);
    this.getProjectType();
  },
  beforeDestroy() {
    clearTimeout(this._reviewTipTimer);
    this._uploadStopped = true;
  },
  methods: {
    // 获取项目列表
    worksList(downLoad, page) {
      const params = {
        is_download: downLoad,
        page: page,
        per_page: 7
      };
      const version = this._listVersion = (this._listVersion || 0) + 1;
      return works(params).then(res => {
        if (this._uploadStopped || version !== this._listVersion) return;
        console.log(res, "项目列表");

        var dateDeal = res.data.data;
        for (let i = 0; i < dateDeal.list.length; i++) {
          let startDate = new Date();
          let endDate = new Date(dateDeal.list[i].expired_at);
          let restDate = endDate - startDate;
          if (restDate > 0) {
            if (restDate / (1000 * 60 * 60 * 24) >= 1) {
              dateDeal.list[i].restDate =
                (restDate / (1000 * 60 * 60 * 24)).toFixed(0) + "天";
            } else if (restDate / (1000 * 60 * 60) >= 1) {
              dateDeal.list[i].restDate =
                (restDate / (1000 * 60 * 60)).toFixed(0) + "小时";
            } else {
              dateDeal.list[i].restDate =
                (restDate / (1000 * 60)).toFixed(0) + "分";
            }
          } else {
            dateDeal.list[i].restDate = -1;
          }

          // dateDeal.list[i].restDate = endDate - startDate;
        }

        console.log(dateDeal, "dateDeal");
        this.projectList = dateDeal;
      });
    },

    // 从上传中的列表，打开弹框
    openFour() {
      this.dynamic = true;
    },

    tabCheckTap(e) {
      if (this.tabCheck === e) return;
      if (e == 0) {
        this.worksList(-1, 1);
        this.currentPage = 1;
      } else {
        this.worksList(0, 1);
        this.currentPage = 1;
      }

      this.$data.tabCheck = e;
    },

    // 打开添加项目弹窗并且处理数据
    dealWithData(event) {
      console.log("event", event);
      if (this.stepsNum == 4) {
        this.dynamic = true;
      } else {
        this.isOauth();
        this.stepsNum = 1;
        // 处理文件名
        const fileName = event.srcElement.files[0].webkitRelativePath.split(
          "/"
        )[0];
        // 处理文件
        this.firstStep.arr.push({
          fileList: event.srcElement.files,
          fileName: fileName
        });
        this.finishingBind();
      }
    },

    // 单独处理图片张数和大小
    finishingBind() {
      const arr = this.firstStep.arr;
      this.firstStep.size = 0;
      this.firstStep.many = 0;
      for (let i = 0; i < arr.length; i++) {
        // 处理图片张数、
        this.firstStep.many = this.firstStep.many + arr[i].fileList.length;
        for (let j = 0; j < arr[i].fileList.length; j++) {
          // 处理图片大小
          this.firstStep.size = this.firstStep.size + arr[i].fileList[j].size;
        }
      }
    },

    // 第一步删除文件夹
    deleteFile(idx) {
      this.firstStep.arr.splice(idx, 1);
      this.finishingBind();
    },

    addPrice(event) {
      this.dealWithData(event);
    },

    nextBtn() {
      const that = this;
      if (this.stepsNum == 1) {
        const arr = this.firstStep.arr;
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < arr[i].fileList.length; j++) {
            const file = arr[i].fileList[j];
            const size = arr[i].fileList[j].size;
            const url = window.URL.createObjectURL(file, { quality: 1 });
            // 压缩图片大小
            lrz(url)
              .then(resLrz => {
                console.log(resLrz.file);
                const imgUrl = window.URL.createObjectURL(resLrz.file);
                that.secondArr.push({
                  url: imgUrl,
                  is_choice: 0,
                  loading: false,
                  path: "/" + file.webkitRelativePath,
                  file: file,
                  size: size,
                  imgLoadPercent: 0
                });
              })
              .catch(error => {});
          }
        }
        this.stepsNum = this.stepsNum + 1;
      } else if (this.stepsNum == 2) {
        if (that.secondXcx.length == 0) {
          this.$message({
            message: "请挑选精选的图片",
            type: "error",
            customClass: "zZindex"
          });

          return;
        } else {
          this.stepsNum = this.stepsNum + 1;
        }
      } else if (this.stepsNum == 3) {
        let info = that.projectInfo;
        if (
          info.name != "" &&
          info.category_id != null &&
          info.customer_industry_id != null &&
          info.customer_phone_list != ""
        ) {
          this.stepsNum = this.stepsNum + 1;
          this.upLoadImg();
        } else {
          this.$message({
            message: "请完善项目信息",
            type: "error",
            customClass: "zZindex"
          });
          return;
        }
      }
    },

    imgLoad(index) {
      // console.log(event);
      this.secondArr[index].loading = true;
    },

    // 选中图片
    checkImg(index, status) {
      const secondArr = this.secondArr;
      const secondXcx = this.secondXcx;
      for (let i = 0; i < secondArr.length; i++) {
        if (i === index) {
          secondArr[i].is_choice = status;
          this.secondArr = secondArr;
          if (status == 1) {
            // if (secondXcx.length == 18) {
            //   this.$message({
            //     message: "选中的图片不能超过18张",
            //     type: "error",
            //     customClass: "zZindex"
            //   });
            //   secondArr[i].is_choice = 0;
            // } else {
              secondXcx.push(secondArr[i]);
              this.secondXcx = secondXcx;
              secondArr[i].is_choice = 1;
            // }
          } else {
            for (let j = 0; j < secondXcx.length; j++) {
              if (secondArr[i].url == secondXcx[j].url) {
                secondXcx.splice(j, 1);
                secondArr[i].is_choice = 0;
              }
            }
          }
        }
      }
    },
    
    // 取消精选
    cancelSe(index){
      const secondArr = this.secondArr;
      const secondXcx = this.secondXcx;
      const url = this.secondXcx[index].url

      for(let i=0;i<secondArr.length;i++){
        if(url == secondArr[i].url){
          secondArr[i].is_choice = 0;
        }

      }

      secondXcx.splice(index,1)



    },

    // 上一步
    upStep() {
      this.stepsNum = this.stepsNum - 1;
    },
    // 关闭弹窗
    stepsClose() {
      if (this.stepsNum != 4) {
        this.project1 = "";
        this.project2 = "";
        this.project3 = "";
        this.project4 = "";
        this.stepsNum = 0;
        this.firstStep = { arr: [], size: 0, many: 0 };
        this.secondArr = [];
        this.secondXcx = [];
        this.projectInfo = {
          name: "",
          category_id: null,
          customer_industry_id: null,
          customer_phone_list: "",
          is_sync_pan: 0,
          file_list: []
        };
        this.upLoadCover = [];
      } else {
        this.dynamic = false;
      }
    },

    // 分页输入框处理
    onEnter(e) {
      var that = this;
      if (e.code == "Enter") {
        if (this.inputValue == "" || this.inputValue == "0") {
          this.currentPage = 1;
          that.currentChange(1);
        } else {
          this.currentPage = parseInt(this.inputValue);
          that.currentChange(parseInt(this.inputValue));
        }
      } else {
        if (e.data != null) {
          this.inputValue = this.inputValue + e.data;
        } else {
          this.inputValue = this.inputValue.substring(
            0,
            this.inputValue.length - 1
          );
        }
      }
    },

    //下一页处理
    currentChange(event) {
      var that = this;
      var tabCheck = this.tabCheck;
      if (tabCheck == 0) {
        that.worksList(-1, event);
      } else if (tabCheck == 1) {
        that.worksList(0, event);
      }
    },

    // 获取客户行业,作品类型
    getProjectType() {
      customerIndustries().then(res => {
        this.customerIn = res.data.data;
        console.log(res, "客户行业");
      });
      workCategories().then(res => {
        this.projectIn = res.data.data;
        console.log(res, "作品类型");
      });
    },
    // 项目名
    projectName(event) {
      this.projectInfo.name = event.target.value;
    },
    // 作品类型处理
    categoryId(event) {
      this.project1 = event.name;
      this.project2 = "";
      this.projectInfo.category_id = null;
      this.projectTwoIn = event.children;
    },
    categoryIdTwo(event) {
      this.project2 = event.name;
      this.projectInfo.category_id = event.id;
    },

    // 客户行业处理
    customerId(event) {
      this.project3 = event.name;
      this.project4 = "";
      this.projectInfo.customer_industry_id = null;
      this.customerTwoIn = event.children;
    },
    customerTwoId(event) {
      this.project4 = event.name;
      this.projectInfo.customer_industry_id = event.id;
    },
    // 提取人手机号
    phoneList(event) {
      console.log(event);
      this.projectInfo.customer_phone_list = event.target.value;
    },
    // 是否同步至百度网盘
    synchronous(event) {
      if (event) {
        this.projectInfo.is_sync_pan = 1;
      } else {
        this.projectInfo.is_sync_pan = 0;
      }
    },
    // 每批文件全部就绪后只创建一次项目；失败重试复用已上传的文件。
    upLoadImg() {
      if (this._uploadPending) return this._uploadPending;
      const items = this.secondArr;
      if (!items.length) { this.stepsNum = 3; return Promise.resolve(false); }
      this.upLoadIng = items;
      const active = () => !this._uploadStopped && this.secondArr === items;
      const pending = Promise.all(items.map(item =>
        this.upLoad(item, active).then(() => null, error => error)
      )).then(errors => {
        if (!active()) return;
        const error = errors.find(Boolean);
        if (error) throw error;
        return this.createProject(items).then(() => {
          if (!active()) return;
          this.stepsNum = 5;
          this.worksList(-1, 1).catch(() => {});
        });
      }).catch(error => {
        if (active()) {
          this.stepsNum = 3;
          if (error.moderation) {
            this.reviewTip = true;
            clearTimeout(this._reviewTipTimer);
            this._reviewTipTimer = setTimeout(() => { this.reviewTip = false; }, 1600);
          }
        }
        console.error("交付未完成", error);
        return false;
      }).finally(() => {
        if (this._uploadPending === pending) this._uploadPending = null;
      });
      this._uploadPending = pending;
      return pending;
    },

    async upLoad(item, active) {
      if (!active() || item.uploadReady) return;
      if (!item.key) {
        const grant = await qiniuGetParams();
        if (!active()) return;
        const formData = new FormData();
        formData.append("file", item.file);
        formData.append("token", grant.data.data.upToken);
        const response = await this.axios({
          method: "post",
          url: "https://up-z2.qiniup.com",
          data: formData,
          onUploadProgress: progress => {
            if (!active()) return;
            // 传输 100% 仍须等待存储和图片信息确认。
            item.imgLoadPercent = Math.min(99, Math.round(progress.loaded * 100 / (progress.total || item.size || 1)));
            item.loaded = progress.loaded;
          }
        });
        if (!active()) return;
        if (!response.data || !response.data.key) throw new Error("upload_incomplete");
        item.key = response.data.key;
        item.hash = response.data.hash;
      }
      const response = await this.axios({
        method: "get",
        url: "https://file.zuopin.cloud/" + item.key + "?imageInfo"
      });
      if (!active()) return;
      if (!response.data || !response.data.width || !response.data.height) throw new Error("image_info_missing");
      item.width = response.data.width;
      item.height = response.data.height;
      item.uploadReady = true;
      item.imgLoadPercent = 100;
      this.upLoadCover = this.upLoadIng.filter(file => file.uploadReady);
    },

    // 点击传输中
    transmission() {
      let ll = this.transmissionStatus;
      if (ll != 0) {
        this.transmissionStatus = 0;
        // this.showArr = this.upLoadIng;
      }
    },
    // 点击已完成
    coverImg() {
      let ll = this.transmissionStatus;
      if (ll != 1) {
        this.transmissionStatus = 1;
        // this.showArr = this.upLoadCover;
      }
    },

    // 构造本次提交快照，不把表单中的数组原地改成字符串。
    createProject(items) {
      const fileList = items.map(item => ({
        path: item.path,
        object_key: item.key,
        etag: item.hash,
        size: item.size,
        pic_width: item.width,
        pic_height: item.height,
        is_choice: item.is_choice
      }));
      return createPro({ ...this.projectInfo, file_list: JSON.stringify(fileList) }).then(response => {
        if (!response || response.status < 200 || response.status >= 300) {
          const error = new Error("project_create_failed");
          error.moderation = response && response.data && response.data.moderation;
          throw error;
        }
        return response;
      });
    },

    // 下拉菜单的点击事件
    handleCommand(command) {
      if (command.type == "share") {
        // 分享
        this.sharePro(command.id);
      } else if (command.type == "delete") {
        //  删除项目
        this.delectPro(command.id);
      }
    },

    delectPro(id) {
      deleteDetails(id).then(res => {
        console.log(res, "删除成功");
        this.$message({
          message: "删除成功",
          type: "success",
          offset: 300
        });

        let tabCheck = this.tabCheck;
        let page = this.currentPage;
        if (tabCheck == 0) {
          this.worksList(-1, page);
        } else {
          this.worksList(0, page);
        }
      });
    },

    // 分享项目
    sharePro(id) {
      var that = this;
      var clipboard = new Clipboard(".shareUrl");
      clipboard.on("success", e => {
        this.$message({
          message: "连接复制成功",
          type: "success",
          offset: 300
        });
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        this.$message({
          message: "连接复制失败，请重新复制",
          type: "error",
          offset: 300
        });
        clipboard.destroy();
      });
    },

    // 项目详情
    getProDetails(workId, status) {
      var that = this;
      if (status != -1) {
        this.$router.push({
          path: "/projectDetails",
          query: {
            id: workId
          }
        });
      } else {
        this.$message({
          message: "该项目已过期",
          type: "error",
          offset: 300
        });
      }
    },

    //退出
    outOk() {
      var that = this;
      var storage = window.localStorage;
      storage.clear();
      this.$route.push({
        path: "/"
      });
    },

    // 是否授权百度网盘
    isOauth() {
      var that = this;
      var params = {
        is_display_username: 1
      };
      isOauth(params).then(res => {
        console.log(res, "判断是否授权");
        this.baiduIsOauth = res.data.data;
      });
    },

    // 绑定百度网盘
    bindBaidu() {
      let _this = this;
      window.open(
        "https://openapi.baidu.com/oauth/2.0/authorize?response_type=token&client_id=2n959zvKCVgAg0rQ1jiGwSGS&scope=basic,netdisk&state=STATE&redirect_uri=https://zuopin.cloud/home/#/userHome"
      );
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 83%;
  min-width: 1000px;
  margin: auto;
  .tabTop {
    margin: 39px 0px;
    .tab {
      width: 210px;
      height: 32px;
      border-radius: 20px;
      color: #666666;
      border: 1px solid rgba(201, 201, 201, 1);
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .allp {
        width: 98px;
        height: 100%;
        border-radius: 24px;
        line-height: 2.5;
        text-align: center;
      }
      .noDownp {
        width:112px;
        height: 100%;
        border-radius: 24px;
        line-height: 2.5;
        text-align: center;
      }
      .checkTap {
        background: #000;
        color: #ffffff;
      }
    }
  }
  .projectList {
    height: 450px;
    .projectItem {
      height: 45px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .itemleft {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .projectName {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
        .projectInfo {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .itemRight {
        .partInfo {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          display: flex;
          align-items: center;
          .projectStatus {
            background: #8e8e8e;
            z-index: 100;
            animation: water-wave linear infinite;
            overflow: hidden;
            width: 110px;
            height: 26px;
            .progressDiv {
              position: absolute;
              top: -40px;
              background: #3ecdf6;
              height: 110px;
              width: 110px;
              border-radius: 40%;
              animation: inherit;
              animation-duration: 4s;
            }
            .topLayer {
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              z-index: 10;
              color: #ffffff;
            }
            .projectDropDown {
              position: absolute;
              left: 0;
              top: 30px;
              width: 110px;
              height: 70px;
              box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
              border-radius: 8px;
              background: #ffffff;
              .optionsItem {
                width: 110px;
                height: 35px;
                text-align: center;
                line-height: 35px;
              }
            }
          }
          .downloadStyle {
            width: 110px;
            height: 26px;
            border-radius: 13px;
            line-height: 26px;
            margin-left: 12px;
            position: relative;
          }
          .styleStatus {
            display: flex;
            justify-content: space-around;
            align-items: center;
            background: #f0f0f0;
            padding: 0px 5px;
            box-sizing: border-box;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            .pointG {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #6cc166;
            }
            .pointR {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #ec4d3d;
            }
          }
        }
      }
    }
  }
  .pagination {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 672px;
    margin: 50px auto;
    .current {
      width: 100px;
      height: 34px;
      border-radius: 20px;
      border: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      .inputCurrent {
        width: 48px;
        height:24px;
        border-radius: 15px;
        background: #f3f3f3;
        margin-left: 8px;
        margin-right: 6px;
        line-height:24px;
        input {
          border: none;
          width: 36px;
          background: none;
          margin-left: 5px;
        }
        input:focus {
          outline: none;
        }
        input::-webkit-input-placeholder {
          color: #c9c9c9;
          font-size: 14px;
        }
      }
    }
  }
}

.maskPopUp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .maskContent {
    width: 700px;
    height: 498px;
    background: #ffffff;
    border-radius: 20px;
    padding: 19px 25px;
    .contentHeader {
      .stepsClose {
        float: right;
      }
      .stepsOne {
        margin-top: 10px;
      }
    }
    .contentMain {
      .stepsTitle {
        margin: 22px 0px;
        display: flex;
        justify-content: space-between;
        .titleName {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
        .titleInfo {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
      }

      .filelist {
        display: flex;
        flex-wrap: wrap;
        height:304px;
        overflow-y: scroll;
        padding-top: 5px;
        .fileItem {
          width: 82px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
          margin: 0 16px 25px 16px;
          .imgDiv {
            position: relative;
            width: 82px;
            height: 82px;
            border-radius: 10px;
            margin-bottom: 17px;
            background: #e5e5e5;
            display: flex;
            justify-content: center;
            align-items: center;
            .folderIcon {
              width: 40px;
              height: 35px;
            }
            .fileClose {
              width: 16px;
              height: 16px;
              position: absolute;
              right: -4.8px;
              top: -4.8px;
            }
          }
        }
        .addFileBtn {
          color: rgba(51, 51, 51, 1);
          margin: 0 16px 25px 16px;
          width: 82px;
          height: 82px;
          border-radius: 10px;
          margin-bottom: 17px;
          background: #e5e5e5;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }

      .classifyFile {
        display: flex;
        // justify-content: space-between;
        .imgList {
          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .allPhoto {
            height: 276px;
            overflow-y: scroll;
            width:384px;
            margin-top: 15px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .imgItem {
              width: 82px;
              height: 82px;
              border-radius: 10px;
              position: relative;
              margin-right: 10px;
              margin-bottom: 15px;
              position: relative;
              .imgLoadMask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.6);
                z-index: 999;
                font-size: 12px;
              }
              .imgItemimg {
                width: 82px;
                height: 82px;
                border-radius: 10px;
                object-fit: cover;
              }
              .checkImg {
                position: absolute;
                right: 12px;
                top: 12px;
              }
            }
          }
          .selectImg {
            width: 290px;
          }
        }
      }

      .addProjectInfo {
        width: 436px;
        margin: auto;
        .projectFormItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 18.2px;

          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .formItem {
            width: 316px;
            display: flex;
            justify-content: space-between;
            .inputBg {
              width: 316px;
              height: 44px;
              background: #f6f6f6;
              border-radius: 22px;
              line-height:44px;
              font-size: 14px;
              input {
                background: #f6f6f6;
                border: none;
                margin-left: 20px;
              }
              input:focus {
                outline: none;
              }
              input::-webkit-input-placeholder {
                color: #c9c9c9;
                font-size: 14px;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(201, 201, 201, 1);
                float: right;
                margin-right: 15px;
              }
            }
            .downDrop {
              width: 153px;
              height: 44px;
              background: #f6f6f6;
              border-radius: 22px;
              line-height: 44px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0px 14px 0px 20px;
              box-sizing: border-box;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }
            .placeholderStyle {
              color: #c9c9c9;
            }
            .formItemTip {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              text-align: center;
              display: flex;
              align-items: center;
              span {
                text-align: top;
                margin-left: 4px;
              }
            }
            .pretentBtn {
              width: 77px;
              height: 26px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              background: rgba(0, 0, 0, 1);
              border-radius: 22px;
              text-align: center;
              line-height: 26px;
              margin: 0px 16px;
            }
            .baiduName {
              margin-left: 24px;
              margin-right: 24px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              text-align: center;
            }
          }
        }
      }

      .progressList {
        .proTip {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .allPro {
          width: 100%;
          height: 6px;
          background: rgba(216, 216, 216, 1);
          border-radius: 3px;
          margin: 14px 0px;
          position: relative;
          .sucPro {
            height: 6px;
            background: rgba(62, 205, 246, 1);
            border-radius: 3px;
            position: absolute;
            top: 0px;
            left: 0px;
          }
        }
        .tabList {
          width: 126px;
          height: 28px;
          border-radius: 50px;
          border: 1px solid #c9c9c9;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          .tabItem {
            width:80px;
            height: 28px;
            text-align: center;
            line-height:28px;
            border-radius: 50px;
            font-size: 12px;
            color: rgba(102, 102, 102, 1);
          }
          .tabCheck {
            color: #ffffff;
            background: #333;
          }
        }

        .progress {
          height: 260px;
          overflow-y: scroll;
          .progressFile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            .fileLeft {
              display: flex;
              align-items: center;
              img {
                width: 50px;
                height: 50px;
                background: #000;
                border-radius: 10px;
                object-fit: cover;
              }
              .fileInfo {
                display: inline-block;
                margin-left: 10px;
                .fileInfoP1 {
                  font-size: 14px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                }
                .fileInfoP2 {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                  margin-top: 8px;
                }
              }
            }
            .fileRight {
              position: relative;
              width: 110px;
              height: 6px;
              background: #d8d8d8;
              border-radius: 3px;
              margin-right: 25px;
              .filePro {
                height: 6px;
                background: #3ecdf6;
                border-radius: 3px;
                position: absolute;
                top: 0px;
                left: 0px;
              }
            }
          }
        }
      }

      .addCover {
        .centerCover {
          width: 272px;
          margin: auto;
          text-align: center;
          img {
            width: 84px;
            height: 84px;
            margin-top: 80px;
            margin-bottom:11px;
          }
          p {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 8px;
          }
          .tipList {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            text-align: left;
            ul {
              li {
                line-height: 26px;
                margin-left: 14px;
              }
            }
          }
        }
        .goDetails {
          width: 161px;
          height: 44px;
          background: rgba(0, 0, 0, 1);
          border-radius: 22px;
          text-align: center;
          line-height: 44px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin:76px auto 0px;
        }
      }

      .next {
        text-align: right;
        margin-top:32px;
        .upStep {
          margin-right: 15px;
        }
        img {
          width: 77px;
          height:45px;
        }
      }
    }
  }
}

.maskOut {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .outMask {
    width:503px;
    height:200px;
    background: #ffffff;
    border-radius: 10px;
    .outClose {
      text-align: right;
      img {
        width: 14px;
        height: 14px;
        margin-right: 20px;
        margin-top: 20px;
      }
    }
    .titleP {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
      text-align: center;
      margin-top: 18px;
    }
    .titleG {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      margin-top: 11px;
    }
    .btnMoni {
      display: flex;
      justify-content: space-between;
      width: 232px;
      margin:25px auto 0px;
      .noOut {
        width: 110px;
        height: 36px;
        border-radius: 18px;
        background: rgba(240, 240, 240, 1);
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .okOut {
        width: 110px;
        height: 36px;
        border-radius: 20px;
        background: #ec4d3d;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .qrCodeView {
     width: 330px;
    height: 394px;
    background: #ffffff;
    border-radius: 10px;
    .closeIcon {
      display: flex;
      justify-content: space-between;
     p {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
      img {
        width: 14px;
        height:14px;
        margin-right:20px;
        margin-top: 20px;
      }
    }
    .qrCodeImg {
      width: 202px;
      height: 202px;
      margin: 46px auto 35px;
      background: #000;
      img {
        width: 202px;
        height: 202px;
      }
    }
    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: rgba(240, 240, 240, 1);
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset000pxrgba(240, 240, 240, 0.5);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0.5);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 1);
  box-shadow: inset000pxrgba(240, 240, 240, 0.5);
}

@keyframes water-wave {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

<style>
.zZindex {
  z-index: 1001 !important;
}
</style>